"use client";

import { useAuthStore } from "./useAuthStore";
import { AuthContextType } from "@/types";

const useAuth = (): AuthContextType => {
  const { user, isLoading, isAuthenticated, isFetching } = useAuthStore();

  return {
    user,
    isLoading,
    isAuthenticated,
    isFetching,
  };
};

export { useAuth };
